<template>
    <div class="modal-card contact-modal-step-two" v-if="project">
        <header class="modal-card-head">
            <p class="modal-card-title">Kontakt {{student.name | prettyName}}</p>

            <button @click="close" class="delete" :aria-label="$t('global.actions.close')" />
        </header>

        <section class="modal-card-body">
            <div class="columns">
                <div class="column">
                    <steps :step="3"/>
                </div>
            </div>

            <p>Her kan du gennemse dit projekt. Når du er tilfreds kan du sende det. <br> Vi sender dig også disse oplysninger på e-mail.</p>
            <br>

            <template v-if="customerIsNewRegistration">
                <p>Da du lige har registereret dig, skal du huske at tjekke din indbakke, efter en velkomst mail hvor du kan aktivere din bruger. Her finder du også dit midlertidige kodeord. Husk at ændre det første gang du logger ind.</p>
                <br>
            </template>

            <b-field horizontal :label="$t('global.forms.project.name')">
                <b-input v-model="project.name" expanded readonly/>
            </b-field>

            <b-field horizontal :label="$t('global.forms.student.name')">
                <b-input v-model="student.name" expanded readonly/>
            </b-field>

            <b-field horizontal :label="$t('global.forms.project.skill')">
                <b-input v-model="skillName" expanded readonly/>
            </b-field>

            <b-field horizontal :label="$t('global.forms.project.message')">
                <b-input v-model="project.message" expanded readonly type="textarea"/>
            </b-field>

            <br>

            <b-notification v-if="success" :active.sync="success" type="is-success" :closable="false">
                <p>Vi har oprettet dit projekt og sendt beskeden afsted.</p>

                <p v-if="customerIsNewRegistration">Du kan trykke herunder for at gå til forsiden, hvor du kan logge ind.</p>

                <p v-else>Da du allerede er logget ind kan du trykke herunder for at gå til projektets side.</p>
            </b-notification>

            <b-notification v-else-if="error" :active.sync="error" type="is-danger">
                Noget gik galt.
            </b-notification>

            <template v-else>
                <p class="has-text-centered">Det eneste du mangler nu, er at acceptere vores <router-link :to="{name: 'terms'}" target="_blank">betingelser for projekter.</router-link></p>
                <br>

                <div class="field has-text-centered">
                    <b-checkbox v-model="acceptedTerms">
                        Jeg har læst og accepterer betingelserne for projekter.
                    </b-checkbox>
                    <br>
                    <p v-if="!acceptedTerms"class="help is-danger">Du mangler at acceptere vores betingelser for nye projekter.</p>
                </div>
            </template>
        </section>

        <footer class="modal-card-foot">
            <b-field grouped position="is-right" style="width: 100%">
                <p class="control">
                    <button class="button is-default no-margin-bottom" @click="back">{{$t('global.actions.back')}}</button>

                    <button v-if="!success" class="button is-primary no-margin-bottom" :class="{'is-loading': isSending}"  @click="submit" :disabled="!acceptedTerms">
                        <span>{{$t('global.actions.send')}}</span>

                        <b-icon icon="send" />
                    </button>

                    <template v-else>
                        <button @click="close" class="button is-primary no-margin-bottom" v-if="customerIsNewRegistration">
                            Afslut
                        </button>

                        <router-link v-else class="button is-primary no-margin-bottom" :to="{ name: 'users.overview' }">
                            Gå til projektet
                        </router-link>
                    </template>
                </p>
            </b-field>
        </footer>
</div>
</template>

<style lang="scss" scoped>
    .buttons {
        .button {
            margin-bottom: 10px;
        }

        .help {
            margin-bottom: 10px;
            margin-top: 0;
            padding: calc(0.375em - 1px) 0.75em;
        }
    }
</style>

<script>
    import { mapGetters, mapMutations } from 'vuex';
    import {
        SET_PROJECT_STEP,
        STEP_TWO,
        NEW_REGISTRATION,
    } from '@/taskflex/students/store/contactForm/_types';
    import Steps from '@/taskflex/students/components/contact/Steps';
    import ProjectService from '@/taskflex/projects/services/ProjectService';

    export default {
        data() {
            return {
                isSending: false,
                success: false,
                error: false,
                acceptedTerms: false,

                newProject: {
                    id: null,
                },
            };
        },

        computed: {
            ...mapGetters('contactForm', [
                'project',
            ]),

            student() {
                const { student } = this.project;

                return student;
            },

            customer() {
                const { customer } = this.project;

                return customer;
            },

            customerIsNewRegistration() {
                const { customerStatus } = this.project;

                return customerStatus === NEW_REGISTRATION;
            },

            skillName() {
                return this.$t(`skills.${this.project.skill.name}.name`);
            },
        },

        methods: {
            ...mapMutations('contactForm', {
                setStep: SET_PROJECT_STEP,
            }),

            back() {
                this.setStep(STEP_TWO);
            },

            submit() {
                if (!this.acceptedTerms || this.success) {
                    return;
                }

                const request = {
                    name: this.project.name,
                    message: this.project.message,
                    skill_id: this.project.skill.id,
                    student_id: this.student.id,
                    customer_id: this.customer.id,
                };

                this.isSending = true;
                this.error = false;

                ProjectService.create(request, ({ data }) => {
                    this.isSending = false;

                    this.newProject = data;
                    this.success = true;
                }, () => {
                    this.isSending = false;
                    this.error = true;
                });
            },

            close() {
                this.$emit('hide');
            },
        },

        components: {
            Steps,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/students/components/contact/StepThree.vue